/**
 * Logic For populating coupons to a cart item
 */

// DOM
const cartItems = [...document.querySelectorAll('.js-cartItem')];

// Parser
const domparser = new DOMParser();

if (cartItems.length > 0) {
    cartItems.forEach(function applyCouponAdd(cartItem) {
        const couponField = cartItem.querySelector('.js-couponCodeMask');
        const couponContainer = cartItem.querySelector('.js-couponCodeContainer');
        const couponAdd = cartItem.querySelector('.js-addCoupon');
        const options = [...cartItem.querySelectorAll('.js-optionSelect')];
        const textInputs = [...cartItem.querySelectorAll('input[type="text"]')];
        const hideElements = [...cartItem.querySelectorAll('.js-hide')];
        const couponRemoves = [...cartItem.querySelectorAll('.js-couponRemove')];
        let selectedValues = [];

        options.forEach(option => {
            const inputToDisableSelector = option.dataset.disable;
            const elementToHideSelector = option.dataset.hide;

            const disableRelated = () => {
                const inputToDisable = cartItem.querySelector(
                    `.${inputToDisableSelector}`
                );
                const elementToHide = cartItem.querySelector(`.${elementToHideSelector}`);

                inputToDisable.disabled = !option.checked;

                if (!option.checked) {
                    inputToDisable.classList.add('-inactive');
                    if (elementToHide) {
                        elementToHide.classList.add('-inactive');
                    }
                } else {
                    inputToDisable.classList.remove('-inactive');
                    if (elementToHide) {
                        elementToHide.classList.remove('-inactive');
                    }
                }
            };

            if (inputToDisableSelector) {
                const inputToDisable = cartItem.querySelector(
                    `.${inputToDisableSelector}`
                );

                disableRelated();
                inputToDisable.parentElement.addEventListener('click', () => {
                    option.checked = true;
                    disableRelated();
                    inputToDisable.focus();
                });
            }

            option.addEventListener('input', () => {
                if (textInputs.length) {
                    textInputs.forEach(input => {
                        input.classList.add('-inactive');
                        input.disabled = true;
                    });

                    hideElements.forEach(element => {
                        element.classList.add('-inactive');
                    });

                    if (inputToDisableSelector) {
                        disableRelated();
                    }
                }
            });
        });

        if (couponAdd) {
            const applyCoupon = () => {
                const couponValue = couponField.value;
                const itemKey = couponAdd.dataset.key;

                selectedValues.push(couponValue);

                if (couponValue) {
                    const domNode = domparser
                        .parseFromString(
                            `
                            <li class="tag">
                                ${couponValue}
                                <a class="tag-remove js-couponRemove" data-value="${couponValue}">Remove</a>
                                <input type="hidden" name="coupons[${itemKey}][]" value="${couponValue}">
                            </li>
                        `,
                            'text/html'
                        )
                        .querySelector('.tag');

                    domNode
                        .querySelector('.js-couponRemove')
                        .addEventListener('click', clickEvent => {
                            clickEvent.preventDefault();
                            selectedValues = selectedValues.filter(
                                value =>
                                    value !==
                                    domNode.querySelector('.js-couponRemove').dataset
                                        .value
                            );
                            domNode.remove();
                        });

                    couponContainer.append(domNode);

                    couponField.value = '';
                }
            };

            couponRemoves.forEach(couponRemove => {
                selectedValues.push(couponRemove.dataset.value);

                couponRemove.addEventListener('click', event => {
                    event.preventDefault();

                    selectedValues = selectedValues.filter(
                        value => value !== couponRemove.dataset.value
                    );
                    couponRemove.parentElement.remove();
                });
            });

            couponAdd.addEventListener('click', event => {
                event.preventDefault();
                applyCoupon();
            });
            couponField.addEventListener('keydown', event => {
                const key = event.charCode || event.keyCode || 0;

                if (key === 13) {
                    event.preventDefault();
                    applyCoupon();
                }
            });

            couponField.addEventListener('input', () => {
                if (
                    couponField.value &&
                    selectedValues.indexOf(couponField.value) === -1
                ) {
                    couponAdd.classList.remove('-inactive');
                } else {
                    couponAdd.classList.add('-inactive');
                }
            });

            couponField.addEventListener('focus', () => {
                if (
                    couponField.value &&
                    selectedValues.indexOf(couponField.value) === -1
                ) {
                    couponAdd.classList.remove('-inactive');
                } else {
                    couponAdd.classList.add('-inactive');
                }
            });
        }
    });
}
